(function () {
  'use strict';

  if (window.subcollectionFilterInitialized) return;
  window.subcollectionFilterInitialized = true;

  var states = new WeakMap();
  var responseCache = new Map();

  function getSection(root) {
    return root && root.closest('[data-section-type="collection-grid"]');
  }

  function getState(root) {
    var section = getSection(root);
    if (!section) return null;

    var state = states.get(section);
    if (state) {
      state.root = root;
      return state;
    }

    var products = section.querySelector('[data-subcollection-products]');
    if (!products) return null;

    state = {
      section: section,
      root: root,
      originalProductsHtml: products.outerHTML,
      activeHandle: '',
      activeTitle: '',
      activeUrl: '',
      abortController: null,
      requestId: 0
    };

    states.set(section, state);
    return state;
  }

  function getWrapper(state) {
    return state.section.querySelector('.collection-grid__wrapper');
  }

  function getProducts(state) {
    return state.section.querySelector('[data-subcollection-products]');
  }

  function setLoading(state, loading) {
    var wrapper = getWrapper(state);
    if (!wrapper) return;

    wrapper.classList.toggle('unload', loading);
    wrapper.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function parseGrid(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var products = parsed.querySelector('[data-subcollection-products]');
    return products ? products.outerHTML : '';
  }

  function fetchGrid(state, collectionUrl, page, sortBy) {
    var requestUrl = new URL(collectionUrl, window.location.origin);
    if (page && page !== '1') requestUrl.searchParams.set('page', page);
    if (sortBy) requestUrl.searchParams.set('sort_by', sortBy);
    requestUrl.searchParams.set('section_id', state.root.dataset.sectionId);

    if (state.abortController) state.abortController.abort();
    var cacheKey = requestUrl.toString();
    if (responseCache.has(cacheKey)) {
      state.abortController = null;
      return Promise.resolve(responseCache.get(cacheKey));
    }

    state.abortController = new AbortController();

    return fetch(requestUrl.toString(), {
      credentials: 'same-origin',
      signal: state.abortController.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load subcollection');
        return response.text();
      })
      .then(function (html) {
        var gridHtml = parseGrid(html);
        if (!gridHtml) throw new Error('Subcollection grid was not found');
        responseCache.set(cacheKey, gridHtml);
        return gridHtml;
      });
  }

  function updateProductGrid(state, gridHtml) {
    var products = getProducts(state);
    if (!products) return;

    products.outerHTML = gridHtml;

    if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
      window.theme.reinitProductGridItem();
    }

    if (window.AOS && typeof window.AOS.refreshHard === 'function') {
      window.AOS.refreshHard();
    }

    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }

  function updateStatus(state, active) {
    var status = state.root.querySelector('[data-subcollection-filter-status]');
    var title = state.root.querySelector('[data-subcollection-filter-title]');
    var clear = state.root.querySelector('[data-subcollection-filter-clear]');
    var announcement = state.root.querySelector('[data-subcollection-filter-announcement]');

    state.root.querySelectorAll('[data-subcollection-filter-link]').forEach(function (link) {
      if (active && link.dataset.subcollectionHandle === state.activeHandle) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    state.section.classList.toggle('is-subcollection-filtered', active);

    if (!status || !title || !clear) return;
    status.hidden = !active;

    if (active) {
      title.textContent = state.activeTitle;
      clear.setAttribute('aria-label', 'Clear ' + state.activeTitle + ' filter');
      if (announcement) announcement.textContent = 'Showing products from ' + state.activeTitle;
    } else {
      title.textContent = '';
      clear.setAttribute('aria-label', 'Clear subcollection filter');
      if (announcement) announcement.textContent = 'Showing all products';
    }
  }

  function updateUrl(state, page, sortBy, replaceHistory) {
    var url = new URL(window.location.href);
    url.searchParams.set('subcollection', state.activeHandle);

    if (page && page !== '1') {
      url.searchParams.set('subcollection_page', page);
    } else {
      url.searchParams.delete('subcollection_page');
    }

    if (sortBy) {
      url.searchParams.set('subcollection_sort', sortBy);
    } else {
      url.searchParams.delete('subcollection_sort');
    }

    url.searchParams.delete('page');
    var method = replaceHistory ? 'replaceState' : 'pushState';
    window.history[method]({}, '', url.pathname + url.search + url.hash);
  }

  function scrollToProducts(state) {
    var target = state.section.querySelector('[data-subcollection-products]');
    if (!target) return;

    var header = document.querySelector('.site-header');
    var offset = header ? header.offsetHeight + 15 : 15;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function activate(state, options) {
    var page = options.page || '1';
    var sortBy = options.sortBy || '';
    var requestId = state.requestId + 1;
    state.requestId = requestId;

    state.activeHandle = options.handle;
    state.activeTitle = options.title;
    state.activeUrl = options.url;

    updateStatus(state, true);
    setLoading(state, true);

    return fetchGrid(state, state.activeUrl, page, sortBy)
      .then(function (gridHtml) {
        if (requestId !== state.requestId) return;
        updateProductGrid(state, gridHtml);
        updateStatus(state, true);
        if (options.updateHistory !== false) {
          updateUrl(state, page, sortBy, options.replaceHistory);
        }
        if (options.scroll !== false) scrollToProducts(state);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        if (requestId === state.requestId) window.location.assign(options.url);
      })
      .finally(function () {
        if (requestId === state.requestId) setLoading(state, false);
      });
  }

  function clear(state, updateHistory) {
    if (state.abortController) state.abortController.abort();
    state.requestId += 1;

    updateProductGrid(state, state.originalProductsHtml);
    state.activeHandle = '';
    state.activeTitle = '';
    state.activeUrl = '';
    updateStatus(state, false);

    if (updateHistory !== false) {
      var url = new URL(window.location.href);
      url.searchParams.delete('subcollection');
      url.searchParams.delete('subcollection_page');
      url.searchParams.delete('subcollection_sort');
      window.history.pushState({}, '', url.pathname + url.search + url.hash);
    }

    if (window.theme && window.theme.sections && typeof window.theme.sections.reinit === 'function') {
      window.theme.sections.reinit('collection-grid');
    }
  }

  function activateFromUrl(root, scroll) {
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('subcollection');
    if (!handle) return false;

    var link = Array.from(root.querySelectorAll('[data-subcollection-filter-link]')).find(function (item) {
      return item.dataset.subcollectionHandle === handle;
    });
    if (!link) return false;

    var state = getState(root);
    if (!state) return false;

    activate(state, {
      handle: handle,
      title: link.dataset.subcollectionTitle,
      url: link.href,
      page: params.get('subcollection_page') || '1',
      sortBy: params.get('subcollection_sort') || '',
      updateHistory: false,
      scroll: scroll
    });

    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-subcollection-filter-link]');
    if (link) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var root = link.closest('[data-subcollection-filter-root]');
      var state = getState(root);
      if (!state) return;

      event.preventDefault();
      activate(state, {
        handle: link.dataset.subcollectionHandle,
        title: link.dataset.subcollectionTitle,
        url: link.href
      });
      return;
    }

    var clearButton = event.target.closest('[data-subcollection-filter-clear]');
    if (clearButton) {
      var clearRoot = clearButton.closest('[data-subcollection-filter-root]');
      var clearState = getState(clearRoot);
      if (!clearState) return;

      event.preventDefault();
      clear(clearState, true);
      return;
    }

    var paginationLink = event.target.closest('.pagination a');
    if (!paginationLink) return;

    var activeSection = paginationLink.closest('.collection-content.is-subcollection-filtered');
    if (!activeSection) return;

    var activeRoot = activeSection.querySelector('[data-subcollection-filter-root]');
    var activeState = getState(activeRoot);
    if (!activeState || !activeState.activeHandle) return;

    event.preventDefault();
    var pageUrl = new URL(paginationLink.href, window.location.origin);
    activate(activeState, {
      handle: activeState.activeHandle,
      title: activeState.activeTitle,
      url: activeState.activeUrl,
      page: pageUrl.searchParams.get('page') || '1',
      sortBy: new URLSearchParams(window.location.search).get('subcollection_sort') || ''
    });
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('#SortBy')) return;

    var activeSection = event.target.closest('.collection-content.is-subcollection-filtered');
    if (!activeSection) return;

    var root = activeSection.querySelector('[data-subcollection-filter-root]');
    var state = getState(root);
    if (!state || !state.activeHandle) return;

    activate(state, {
      handle: state.activeHandle,
      title: state.activeTitle,
      url: state.activeUrl,
      sortBy: event.target.value,
      page: '1',
      scroll: false
    });
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-subcollection-filter-root]').forEach(function (root) {
      var state = getState(root);
      if (!state) return;

      if (!activateFromUrl(root, false) && state.activeHandle) {
        clear(state, false);
      }
    });
  });

  function init() {
    document.querySelectorAll('[data-subcollection-filter-root]').forEach(function (root) {
      getState(root);
      activateFromUrl(root, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
